import { call, put } from 'redux-saga/effects';
import { ListingsAsyncActions } from 'store/actions/listings';
import { apiCall } from 'utils/apiCall';

function* searchListingByAgent(action) {
  const {
    SearchListingsByAgent: {
      Actions: { SUCCESS, FAILURE },
    },
  } = ListingsAsyncActions;
  const {
    payload: { agentId, state },
  } = action;

  try {
    const response = yield call(apiCall, '/search/listings/agents', 'get', { agentId, state });
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default searchListingByAgent;
